
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","id":"ico-edit","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"id":"bg","d":"M0 0h20v20H0z","stroke":"transparent","fill":"none"}}),_c('g',{attrs:{"id":"Gruppe_27711","data-name":"Gruppe 27711","transform":"translate(5 5)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14182","d":"M310.857 381h-2.2v-.346a1.1 1.1 0 00-1.094-1.094H305.4a1.1 1.1 0 00-1.094 1.094V381h-2.2a.374.374 0 000 .748h.735v7.652a1.1 1.1 0 001.09 1h5.1a1.1 1.1 0 001.09-1.007v-7.638h.735a.374.374 0 100-.748zm-5.806-.346a.347.347 0 01.347-.347h2.161a.347.347 0 01.347.347V381h-2.854zm3.978 8.991h-5.1a.349.349 0 01-.345-.315v-7.579h5.785v7.578a.348.348 0 01-.34.32z","data-name":"Pfad 14182","transform":"translate(-301.728 -379.564)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14183","d":"M308.489 387.036a.377.377 0 00-.376.377v3.272a.376.376 0 10.752 0v-3.272a.377.377 0 00-.376-.377z","data-name":"Pfad 14183","transform":"translate(-304.683 -383.022)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Pfad_14184","d":"M312.008 387.036a.377.377 0 00-.376.377v3.272a.376.376 0 10.752 0v-3.272a.377.377 0 00-.376-.377z","data-name":"Pfad 14184","transform":"translate(-306.311 -383.022)"}})])])
          )
        }
      }
    